import { permissionsFrag } from './permissions.gql-types';

export const inboxUserGridItemFrag = `
    id
    name
    surname
    email
`;

export const inboxToUserGridItemFrag = `
    id
    name
    surname
    email
    permissionSet {
        ${permissionsFrag}
    }
`;

const agendaPermissionsFrag = `
    accessToModule
    accessToOrganizationsInbox
    readOrganizationsMessages
    sendOrganizationsMessages
    deleteOrganizationsMessages
    shareOrganizationWithUser
`;

export const inboxUserAgendaDataFrag = `
    permissionsGlobal {
        ${agendaPermissionsFrag}
    }
    permissionsByOrganizations {
        organizationId
        permissions {
            ${agendaPermissionsFrag}
        }
    }
    organizationAccesses
`;
